import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Lead,LeadData } from '../data/lead';
import { MessageHandlerService } from "../../services/message-handler.service"
import { EventEmitter } from '@angular/core';

@Injectable()
export class LeadService extends LeadData {

  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiChat: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  async getLeads(pagination, filter, order) {
    console.log({ pagination, filter, order });
    try {
      let response = await this.http.post(this.api + "leads", { pagination, filter, order }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getLead(id: string) {
    try {

      let chat = <Lead>await this.http.get(this.api + "lead/" + id).toPromise();
      return chat

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async sendLead(id) {
    try {

      let response = <Lead>await this.http.put(this.api + "leads/" + (id || ''),{}).toPromise();
      return response
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message)
    }
  }

}
